import type { SVGProps } from 'react'
const LineTime = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M2 12c0 5.515 4.485 10 10 10s10-4.485 10-10S17.515 2 12 2 2 6.485 2 12m1.5 0c0-4.685 3.815-8.5 8.5-8.5s8.5 3.815 8.5 8.5-3.815 8.5-8.5 8.5-8.5-3.815-8.5-8.5m7.75.31 3.47 3.47 1.06-1.06-3.03-3.03V6.495h-1.5z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineTime }
